import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { HomeGate } from '@/features/account/shell/HomeGate';
import ModuleSuccessPage from '@/features/modules/module-success';
import { ensureOnboardingProgressLoaded } from '@/features/account/onboarding/shared/ensure-onboarding-progress.loader';
import { moduleSearchSchema } from '@/features/modules/shared/module-search.schema';

const conclusaoSearchSchema = moduleSearchSchema.extend({
  modulo: z.string().optional(),
  /**
   * EU-758 — desfecho do Mapa de Decisões. A copy é outra ("Teste concluído!",
   * "Parabéns!") porque o que foi concluído vale por 6 meses e será reaproveitado
   * em outras vagas — a tela precisa dizer isso. Ausente = tela de sempre.
   */
  variante: z.enum(['teste', 'curriculo']).optional(),
});

export const Route = createFileRoute('/modulos/conclusao')({
  validateSearch: conclusaoSearchSchema,
  component: () => (
    <HomeGate>
      <ModuleSuccessPage />
    </HomeGate>
  ),
  loader: ({ context }) => ensureOnboardingProgressLoaded(context),
});
